export default __webpack_public_path__ + "static/AnnualReports_02-4604bff764358dc757ce9b3d349e1851.jpg";